import { render, staticRenderFns } from "./agenda-item.vue?vue&type=template&id=40ca49a0&scoped=true&"
import script from "./agenda-item.vue?vue&type=script&lang=js&"
export * from "./agenda-item.vue?vue&type=script&lang=js&"
import style0 from "./agenda-item.vue?vue&type=style&index=0&id=40ca49a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca49a0",
  null
  
)

export default component.exports